import { OptimizelyDecision } from '@optimizely/optimizely-sdk'

// single source of truth for known feature flags & experiments
// Union of feature flags from classy-embedded-app and classy-checkout
export enum OptimizelyFeatureFlags {
  classy_mparticle = 'classy_mparticle',
  npo_checkout_app_2025 = 'npo_checkout_app_2025',
  npo_checkout_app_2025_aa = 'npo_checkout_app_2025_aa',
}

// userContext is not serializable, so we need to omit it
export type OptimizelyDecisionWithoutUserContext = Omit<OptimizelyDecision, 'userContext'>

export interface OptimizelyContextType {
  featureFlags: {
    [key in OptimizelyFeatureFlags]: OptimizelyDecisionWithoutUserContext
  }
}

// Initialize with all feature flags set to false
export const defaultOptimizelyContext: OptimizelyContextType = {
  featureFlags: Object.values(OptimizelyFeatureFlags).reduce(
    (acc, flag) => ({
      ...acc,
      [flag]: {
        enabled: false,
        variationKey: null,
        variables: {},
        ruleKey: null,
        flagKey: flag,
        reasons: [],
      },
    }),
    {} as Record<OptimizelyFeatureFlags, OptimizelyDecisionWithoutUserContext>,
  ),
}

// URL parameter override type
export type UrlOverrideMap = Record<string, OptimizelyDecisionWithoutUserContext>
